import {createApp, h} from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router';
import './main.css'
import PassGenerator from "@/components/PassGenerator";
import PageNotFound404 from "@/components/PageNotFound404";
import IndexPage from "@/components/IndexPage";
import TranslitPage from "@/components/TranslitPage";

const routes = [
    { path: '/', component: IndexPage,
      meta: { title: 'Menlor.ru — онлайн-инструменты',
              description: 'Главная страница сайта menlor.ru' } },
    { path: '/generator-paroley', component: PassGenerator,
      meta: { title: 'Генератор паролей — Menlor.ru',
              description: 'Онлайн генератор безопасных паролей с настройкой длины, символов и количества вариантов.' } },
    { path: '/translit', component: TranslitPage,
      meta: { title: 'Транслитерация кириллицы в латиницу — Menlor.ru',
              description: 'Транслитерация кириллицы в латиницу и обратно по ГОСТ 7.79-2000 и для автомобильных госномеров.' } },
    { path: '/:pathMatch(.*)*', component: PageNotFound404,
      meta: { title: '404 — Menlor.ru',
              description: 'Страница не найдена' } } ,
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.afterEach((to) => {
    document.title = to.meta.title || 'Menlor.ru'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc){
        metaDesc.setAttribute('content', to.meta.description || '')
    }
})

const app = createApp({
    render: ()=>h(App)
})

app.use(router)
app.mount('#app')